<template>
  <nav
    class="md:left-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden shadow-xl bg-white flex flex-wrap items-center justify-between relative md:w-64 z-10 py-4 px-6"
  >
    <div
      class="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto"
    >
      <!-- Toggler -->
      <button
        class="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
        type="button"
        v-on:click="toggleCollapseShow('bg-white m-2 py-3 px-6')"
      >
        <i class="fas fa-bars"></i>
      </button>
      <!-- Brand -->
      <router-link
        class="md:block text-left md:pb-2 text-respina-primary mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0"
        to="/airport-board"
      >
        <span class="flex items-center">
          <img
            :src="logoUrl"
            alt="Respina"
            class="h-6 w-auto"
          />
        </span>
      </router-link>
      <!-- Collapse -->
      <div
        class="md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:mt-4 md:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded"
        v-bind:class="collapseShow"
      >
        <!-- Collapse header -->
        <div
          class="md:min-w-full md:hidden block pb-4 mb-4 border-b border-solid border-gray-200"
        >
          <div class="flex flex-wrap">
            <div class="w-6/12">
              <router-link
                class="md:block text-left md:pb-2 text-respina-primary mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0"
                to="/airport-board"
              >
                <img :src="logoUrl" alt="Respina" class="h-6 w-auto" />
              </router-link>
            </div>
            <div class="w-6/12 flex justify-end">
              <button
                type="button"
                class="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
                v-on:click="toggleCollapseShow('hidden')"
              >
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>
        <!-- Divider -->
        <hr class="my-4 md:min-w-full" />
        <!-- Heading -->
        <h6
          class="md:min-w-full text-gray-500 text-xs uppercase font-bold block pt-1 pb-4 no-underline"
        >
          Navigation
        </h6>
        <!-- Navigation -->

        <ul class="md:flex-col md:min-w-full flex flex-col list-none">
          <li class="items-center">
            <router-link
              to="/airport-board"
              v-slot="{ href, navigate, isActive }"
            >
              <a
                :href="href"
                @click="navigate"
                class="text-xs uppercase py-3 font-bold block"
                :class="[
                  isActive
                    ? 'text-respina-primary hover:text-respina-secondary'
                    : 'text-gray-700 hover:text-respina-primary',
                ]"
              >
                <i
                  class="fas fa-plane-departure mr-2 text-sm"
                  :class="[isActive ? 'opacity-75' : 'text-gray-300']"
                ></i>
                Flight Board
              </a>
            </router-link>
          </li>
          <li class="items-center">
            <router-link
              to="/privacy"
              v-slot="{ href, navigate, isActive }"
            >
              <a
                :href="href"
                @click="navigate"
                class="text-xs uppercase py-3 font-bold block"
                :class="[
                  isActive
                    ? 'text-respina-primary hover:text-respina-secondary'
                    : 'text-gray-700 hover:text-respina-primary',
                ]"
              >
                <i
                  class="fas fa-shield-alt mr-2 text-sm"
                  :class="[isActive ? 'opacity-75' : 'text-gray-300']"
                ></i>
                Privacy Policy
              </a>
            </router-link>
          </li>
          <li class="items-center">
            <router-link
              to="/support"
              v-slot="{ href, navigate, isActive }"
            >
              <a
                :href="href"
                @click="navigate"
                class="text-xs uppercase py-3 font-bold block"
                :class="[
                  isActive
                    ? 'text-respina-primary hover:text-respina-secondary'
                    : 'text-gray-700 hover:text-respina-primary',
                ]"
              >
                <i
                  class="fas fa-headset mr-2 text-sm"
                  :class="[isActive ? 'opacity-75' : 'text-gray-300']"
                ></i>
                Support
              </a>
            </router-link>
          </li>
          <li v-if="user?.isAdmin" class="items-center">
            <router-link
              to="/configuration"
              v-slot="{ href, navigate, isActive }"
            >
              <a
                :href="href"
                @click="navigate"
                class="text-xs uppercase py-3 font-bold block"
                :class="[
                  isActive
                    ? 'text-respina-primary hover:text-respina-secondary'
                    : 'text-gray-700 hover:text-respina-primary',
                ]"
              >
                <i
                  class="fas fa-cog mr-2 text-sm"
                  :class="[isActive ? 'opacity-75' : 'text-gray-300']"
                ></i>
                Configuration
              </a>
            </router-link>
          </li>
          <li v-if="user?.isAdmin" class="items-center">
            <router-link
              to="/user-management"
              v-slot="{ href, navigate, isActive }"
            >
              <a
                :href="href"
                @click="navigate"
                class="text-xs uppercase py-3 font-bold block"
                :class="[
                  isActive
                    ? 'text-respina-primary hover:text-respina-secondary'
                    : 'text-gray-700 hover:text-respina-primary',
                ]"
              >
                <i
                  class="fas fa-users-cog mr-2 text-sm"
                  :class="[isActive ? 'opacity-75' : 'text-gray-300']"
                ></i>
                User Management
              </a>
            </router-link>
          </li>
          <li v-if="user?.isAdmin || user?.isSupport" class="items-center">
            <router-link
              to="/text-to-speech"
              v-slot="{ href, navigate, isActive }"
            >
              <a
                :href="href"
                @click="navigate"
                class="text-xs uppercase py-3 font-bold block"
                :class="[
                  isActive
                    ? 'text-respina-primary hover:text-respina-secondary'
                    : 'text-gray-700 hover:text-respina-primary',
                ]"
              >
                <i
                  class="fas fa-microphone-alt mr-2 text-sm"
                  :class="[isActive ? 'opacity-75' : 'text-gray-300']"
                ></i>
                Text to Speech
              </a>
            </router-link>
          </li>
        </ul>

        <hr class="my-4 md:min-w-full" />
        <h6
          class="md:min-w-full text-gray-500 text-xs uppercase font-bold block pt-1 pb-4 no-underline"
        >
          Favorites
        </h6>
        <ul class="md:flex-col md:min-w-full flex flex-col list-none">
          <li v-if="!favorites.length" class="text-xs text-gray-400 py-2">
            No favorites yet.
          </li>
          <li v-for="f in favorites" :key="`${f.type}:${f.value}`" class="py-1">
            <div class="flex items-center justify-between gap-2">
              <button
                type="button"
                class="text-left text-xs font-bold text-gray-700 hover:text-respina-primary truncate"
                @click="goToFavorite(f)"
                :title="f.label || f.value"
              >
                <i
                  class="fas fa-star mr-2 text-xs"
                  style="color: var(--respinaStar, #f58357)"
                ></i>
                {{ f.label || f.value }}
              </button>
              <button
                type="button"
                class="text-gray-300 hover:text-gray-500"
                title="Remove"
                @click="removeFav(f)"
              >
                ×
              </button>
            </div>
          </li>
        </ul>

        <hr class="my-4 md:min-w-full" />
        <div v-if="user" class="py-2">
          <div class="text-xs text-gray-500 mb-2">{{ user.email }}</div>
          <router-link
            to="/profile"
            v-slot="{ href, navigate, isActive }"
          >
            <a
              :href="href"
              @click="navigate"
              class="text-xs uppercase py-2 font-bold block"
              :class="[isActive ? 'text-respina-primary' : 'text-gray-700 hover:text-respina-primary']"
            >
              <i class="fas fa-key mr-2 text-sm" :class="[isActive ? 'opacity-75' : 'text-gray-300']"></i>
              Change Password
            </a>
          </router-link>
          <button
            type="button"
            @click="logout"
            class="text-xs uppercase py-2 font-bold block text-red-600 hover:text-red-700"
          >
            <i class="fas fa-sign-out-alt mr-2 text-sm"></i>
            Logout
          </button>
          <button
            type="button"
            @click="confirmDeleteAccount"
            class="text-xs uppercase py-2 font-bold block text-red-400 hover:text-red-600 mt-1"
          >
            <i class="fas fa-trash-alt mr-2 text-sm"></i>
            Delete Account
          </button>
        </div>
        <div v-else class="py-2">
          <button
            type="button"
            @click="goToLogin"
            class="text-xs uppercase py-2 font-bold block text-respina-primary hover:text-respina-secondary"
          >
            <i class="fas fa-sign-in-alt mr-2 text-sm"></i>
            Login
          </button>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { getUser, clearAuth, refreshUser, deleteAccount } from "@/lib/auth";
import logoUrl from "@/assets/respina/logo.png";
import {
  clearFavoritesCache,
  getFavorites,
  loadFavorites,
  onFavoritesChanged,
  removeFavorite,
} from "@/lib/favorites";

export default {
  data() {
    return {
      collapseShow: "hidden",
      user: getUser(),
      logoUrl,
      favorites: getFavorites(),
      offFav: null,
      offAuth: null,
    };
  },
  async mounted() {
    const u = await refreshUser();
    if (u) this.user = u;
    this.offFav = onFavoritesChanged((items) => {
      this.favorites = items;
    });
    loadFavorites().catch(() => {
      // ignore (e.g. backend down)
    });

    if (typeof window !== "undefined") {
      this.offAuth = () => {
        this.user = getUser();
      };
      window.addEventListener("respina-auth-changed", this.offAuth);
    }
  },
  beforeUnmount() {
    this.offFav?.();
    if (this.offAuth && typeof window !== "undefined") {
      window.removeEventListener("respina-auth-changed", this.offAuth);
    }
  },
  methods: {
    toggleCollapseShow(classes) {
      this.collapseShow = classes;
    },
    goToFavorite(f) {
      const type = f?.type;
      const value = f?.value;
      if (!type || !value) return;
      if (type === "airport") {
        this.$router.push({ path: "/airport-board", query: { mode: "airport", airport: value } });
      } else if (type === "flight") {
        this.$router.push({ path: "/airport-board", query: { mode: "flight", flight: value } });
      } else if (type === "airline") {
        this.$router.push({ path: "/airport-board", query: { mode: "airline", airline: value } });
      }
      this.collapseShow = "hidden";
    },
    async removeFav(f) {
      if (!f?.type || !f?.value) return;
      try {
        await removeFavorite(f.type, f.value);
      } catch {
        // ignore
      }
    },
    logout() {
      clearAuth();
      clearFavoritesCache();
      this.user = null;
      this.favorites = [];
      this.$router.push("/airport-board");
    },
    goToLogin() {
      this.$router.push("/auth/login");
    },
    async confirmDeleteAccount() {
      const ok = window.confirm(
        "Are you sure you want to permanently delete your account? This action cannot be undone. All your data and favorites will be removed."
      );
      if (!ok) return;
      try {
        await deleteAccount();
        clearFavoritesCache();
        this.user = null;
        this.favorites = [];
        this.$router.push("/airport-board");
      } catch (e) {
        alert(e?.message || "Failed to delete account. Please try again.");
      }
    },
  },
};
</script>
